// import { Ref, useForm } from "react-hook-form";
import { InductionQuestionConfiguration } from "../TypesOrInterfaces/induction"
import Input from "../components/Form/Input"
import { formatDateYYYYMMDD } from "./format"
// const { register, handleSubmit, errors } = useForm();


export const HTMLType = (inductionType: string): string => {
    const typesInduction = {
        texto: (): string => "text",
        textolongo: (): string => "textarea",

    } as any

    return typesInduction[inductionType]()
}

export const HTMLElement = (questionField: InductionQuestionConfiguration, RefElement: any, defaultValue: string = '', errors: any, register: any,name:any = null ,disabled:boolean = false,required:boolean = false,onBlur:Function = () => undefined,...rest:any) => {
    const fieldName = name || String(questionField.questionAlias.toLocaleLowerCase());
    const isFieldRequired = required || questionField.isRequired;
    const fieldError = errors[fieldName]?.message;
    const label = String(questionField.title || '').replace(/\s*\*+\s*/g, ' ').replace(/\s+/g, ' ').trim();
    const extraProps = rest.reduce((ac: any, e: any) => ({ ...ac, [e.name]: e }), {});
    const renderRequiredLabel = () => (
        <>
            {label}
            {isFieldRequired && <span className="required-indicator" aria-hidden="true">*</span>}
        </>
    );

    const typesInduction = {
        "textolongo": () => {
            return (
                <div className="control">
                    <label htmlFor={fieldName}>
                        {renderRequiredLabel()}
                    </label>
                    <textarea
                        id={fieldName}
                        name={fieldName}
                        cols={10}
                        rows={10}
                        defaultValue={defaultValue}
                        placeholder={label}
                        ref={RefElement}
                        required={isFieldRequired}
                        onBlur={onBlur}
                        {...extraProps}
                    >
                    </textarea>
                    {fieldError && <span className="input-error-message">{fieldError}</span>}
                </div>
            );
        },
        "lista": (onChange: Function = (e: React.ChangeEvent) => { console.log(`Evento default: ${e.target}`) }) => {                
            return (
                <div className="control">
                    <label htmlFor={fieldName}>
                        {renderRequiredLabel()}
                    </label>
                    <select
                        id={fieldName}
                        name={fieldName}
                        onChange={event => onChange(event)}
                        ref={RefElement}
                        defaultValue={defaultValue}
                        required={isFieldRequired}
                        onBlur={onBlur}
                        {...extraProps}
                    >
                        {/* <option value=''></option> */}
                        {questionField.allowedValues?.map(allowedValue => (
                            <option key={allowedValue.value} value={allowedValue.value}>
                                {allowedValue.label}
                            </option>
                        ))}
                    </select>
                    {fieldError && <span className="input-error-message">{fieldError}</span>}
                </div>
            )
        },

        "checkbox": () => {
            return (
                <div className="control">
                    <input
                        id={fieldName}
                        type="checkbox"
                        name={fieldName}
                        style={{ width: '15px', height: '15px', marginLeft: '2%' }}
                        defaultChecked={`${defaultValue}` === 'true'}
                        ref={RefElement}
                        required={isFieldRequired}
                        onBlur={onBlur}
                        {...extraProps}
                    />
                    <label style={{ marginLeft: '0.5rem' }} htmlFor={fieldName}>{renderRequiredLabel()}</label>
                    {fieldError && <span className="input-error-message">{fieldError}</span>}
                </div>
            );
        },

        "texto": () => {
            return typesInduction.default()
        },
        "data": () => {
            
            return (
                <div className="control">
                    <label htmlFor={fieldName}>
                        {renderRequiredLabel()}
                    </label>
                    <input
                        id={fieldName}
                        type="date"
                        name={fieldName}
                        max={new Intl.DateTimeFormat('fr-ca').format(new Date())}
                        defaultValue= {(formatDateYYYYMMDD(defaultValue))}
                        ref={RefElement}
                        required={isFieldRequired}
                        onBlur={onBlur}
                        {...extraProps}
                    />
                    {fieldError && <span className="input-error-message">{fieldError}</span>}
                </div>
            )
        },
        "cel": () => {
            return (
                <div className="control">
                    <label htmlFor={fieldName}>
                        {renderRequiredLabel()}
                    </label>

                    <Input
                        register={register}
                        errors={errors}
                        mask="(99) 9 9999-9999"
                        type="tel"
                        placeholder={label}
                        name={fieldName}
                        defaultValue={defaultValue?.match(/\d+/g)?.join('')}
                        errorMessage={`${label} obrigatório`}
                        required={isFieldRequired}
                        key={questionField.id}
                        onBlur={onBlur}
                        {...extraProps}
                    />
                </div>);
        },
        "telefone": () => {
            return (
                <div className="control">
                    <label htmlFor={fieldName}>
                        {renderRequiredLabel()}
                    </label>

                    <Input
                        register={register}
                        errors={errors}
                        mask="(99) 9999-9999"
                        type="tel"
                        placeholder={label}
                        name={fieldName}
                        defaultValue={defaultValue?.match(/\d+/g)?.join('')}
                        errorMessage={`${label} obrigatório`}
                        required={isFieldRequired}
                        key={questionField.id}
                        onBlur={onBlur}
                        {...extraProps}
                    />
                </div>);
        },
        "cpf":()=>{
            return (
                <div className="control">
                    <label htmlFor={fieldName}>
                        {renderRequiredLabel()}
                    </label>

                    <Input
                        register={register}
                        errors={errors}
                        mask= {defaultValue ? '' : "999.999.999-99"}
                        type="text"
                        placeholder={label}
                        name={fieldName}
                        defaultValue={defaultValue}
                        errorMessage={`${label} obrigatório`}
                        required={isFieldRequired}
                        key={questionField.id}
                        onBlur={onBlur}
                        {...extraProps}
                    />
                </div>
            )
        },
        "cep":()=>{
            return (
                <div className="control">
                    <label htmlFor={fieldName}>
                        {renderRequiredLabel()}
                    </label>
                    <Input
                        register={register}
                        errors={errors}
                        mask= {defaultValue ? '' : "99999-999"}
                        type="text"
                        placeholder={label}
                        name={fieldName}
                        defaultValue={defaultValue}
                        errorMessage={`${label} obrigatório`}
                        min={1}
                        required={isFieldRequired}
                        value = {defaultValue}
                        disabled = {disabled}
                        key={questionField.questionAlias.toLowerCase()}
                        onBlur={onBlur}
                        {...extraProps}
                    />
                </div>
            )

        },

        "default": () => {
            
            return (
                <div className="control">
                    <label htmlFor={fieldName}>
                        {renderRequiredLabel()}
                    </label>
                    <Input
                        type={questionField.questionType}
                        key={questionField.questionAlias.toLowerCase()}
                        name={fieldName}
                        defaultValue={defaultValue}
                        placeholder={label}
                        register={register}
                        value = {defaultValue}
                        errors={errors}
                        disabled={disabled}
                        required={isFieldRequired}
                        onBlur={onBlur}
                        {...extraProps}
                        
                    />
                </div>
            )
        }

    } as any

    
    let FieldType = apiAliasToHTMLElment(questionField.questionAlias) || questionField.questionType.toLocaleLowerCase()
    return typesInduction[FieldType]()
}


const apiAliasToHTMLElment = (questionAlias: string = ''): any => {

    // let FieldType = questionAlias.includes('Phone') ||  questionAlias.includes('CellPhone') ? 'telefone' : null


    const aliasToType = {
        question_caregiver_cpf: 'cpf',
        question_caregiver_zipcode:'cep',
        question_caregiver_cellphone: 'cel',
        question_caregiver_phone: 'telefone',

    } as any     

    return aliasToType[questionAlias.toLowerCase()] || null;
}
